import type { TextFieldProps } from "@mui/material";

export enum DateRangePickerViews {
  DAY = "day",
  MONTH = "month",
  YEAR = "year",
}

export type IDateRangePickerChipDateConfig = (() => Date) | null;

export interface IDateRangePickerChip<Chip extends string = string> {
  label: string;
  value: Chip;
  startDate: IDateRangePickerChipDateConfig;
  endDate: IDateRangePickerChipDateConfig;
}

export interface IDateRangePickerInnerChip<Chip extends string = string> {
  label: string;
  value: Chip;
  startDate: Date | null;
  endDate: Date | null;
}

export interface IDateRange {
  startDate: Date | null;
  endDate: Date | null;
}

export interface IDateRangeChip<Chip extends string = string> {
  range: IDateRange;
  chip?: Chip | null;
}

export type OnChangeDateRange<Chip extends string = string> = (value: IDateRange, chip: Chip | null) => void;

export type TDateRangePickerViews = Partial<Record<DateRangePickerViews, boolean>>;

export type TDateRangePicker<Chip extends string = string> = {
  anchorEl: Element | null;
  open: boolean;
  value: IDateRange;
  onClose?: OnChangeDateRange<Chip>;
  onChange: OnChangeDateRange<Chip>;
  defaultView?: DateRangePickerViews;
  views?: TDateRangePickerViews;
  chips?: IDateRangePickerChip<Chip>[];
  chip?: Chip | null;
  required?: { startDate: boolean; endDate: boolean };
  minDate?: Date;
  maxDate?: Date;
};

export type TDateRangePickerTextField<Chip extends string = string> = Omit<
  TextFieldProps,
  "value" | "onChange" | "ref" | "onMouseDown" | "required"
> & {
  value: IDateRange;
  onClose?: OnChangeDateRange<Chip>;
  onChange: OnChangeDateRange<Chip>;
  defaultView?: DateRangePickerViews;
  views?: TDateRangePickerViews;
  chips?: IDateRangePickerChip<Chip>[];
  chip?: Chip | null;
  required?: { startDate: boolean; endDate: boolean };
  minDate?: Date;
  maxDate?: Date;
  endDateDisabled?: boolean;
};

export interface IDRPHeaderForm {
  startDate: string;
  endDate: string;
}
